/** Global Variables **/
//var cacheVersion = '1';		// controls version for cookies and cache data in store selector 
var provincecookieKey = 'selected-province' + cacheVersion;

var storenameCookieKey = "selected-store-name" + cacheVersion;
//var postalCodeCookieKey = "user-postal-code"+ cacheVersion;
var __defaultProvince  = 'BC';

var gaStorenameCookieKey = "_coast_ga_storename"; 

/** end of Global Variables **/

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  };


function readStoreSelectorCookie(name){
 return readCookie(name);    
}



function showGeoError(error) {
  return;
  switch(error.code) {
    case error.PERMISSION_DENIED:
      //alert("User denied the request for Geolocation.");
      break;
    case error.POSITION_UNAVAILABLE:
      //alert(x.innerHTML = "Location information is unavailable.");
      break;
    case error.TIMEOUT:
      //alert(x.innerHTML = "The request to get user location timed out.");
      break;
    case error.UNKNOWN_ERROR:
      //alert(x.innerHTML = "An unknown error occurred.");
      break;
  }
  
}

function getLocation(success, error) {
  //alert('getlocation');
  if (navigator.geolocation) {
    
    var options = {
     enableHighAccuracy: true,
     timeout: 5000,
     maximumAge: 0
   	};
    
    navigator.geolocation.getCurrentPosition(success, error, options);
  } else {
   //alert("Geolocation is not supported by this browser.");
  }
}


function loadClosetStore(position)
{
  //alert('loadClosetStore');
  GetProvince(position);
}


function store_selector_provinceChanged(ddl) {
  
  var province = ddl.value;
  // first clear all the hidden stores 
  // todo
  
  // now select all the stores 
  var allstores = $('.map__store-list-store-selector');
  // hide all of them
  allstores.children().each(function () {
    if ($(this).hasClass('hiddenStore') === false) {
      $(this).addClass('hiddenStore');
    }
  });
  if (province != '')
  {
    
      // show only the ones we need 
    var stores = $('.map__store-list-store-selector').find($('[province--id='+ province +']'))

    stores.removeClass('hiddenStore');

    // set the first one as selected 
    $('.map__store-list-store-selector').children().each(function () {
        if ($(this).hasClass('hiddenStore') === false) {
        $(this).find('button').trigger('click');
          return false;
      }
    });
  }

}

//selected-Coast-store cookie --- When manually select a location, save the location data to cookie
function store_selector_storeSelected(days)
{
   var intdays;
  try
  {
    intdays = parseInt(days);
  }
  catch {
    	//alert('here');
    	intdays = 1;
    }
  var province = $('.store-selector__ddlProvince').val();
  var storeid = $('.map__store-list-store-selector').find($('[aria-expanded=true]')).attr('store--id');
  var store_region = $('.map__store-list-store-selector').find($('[aria-expanded=true]')).attr('store--region');
  var store_name = $('.map__store-list-store-selector').find($('[aria-expanded=true]')).attr('store--name');
  if (storeid === undefined)
  {
    storeid = $('.map__store-list-store-selector').find($('.selected__store')).attr('store--id');
  }
  
  if (store_region === undefined){
    store_region = $('.map__store-list-store-selector').find($('.selected__store')).attr('store--region');
  }
  
  var date = new Date();
  date.setTime(date.getTime()+(intdays*24*60*60*1000));
  var expires = "; expires="+date.toGMTString();
  WriteStoreCookie(province, storeid, store_region, defaultStoreCookieDuration);
  //var provincecookieKey = 'selected-province';
  document.cookie = provincecookieKey + "="+ province+";" +expires+"; path=/";
  var lastStoreCookieKey = 'last-selected-store';
  document.cookie = lastStoreCookieKey + "="+ storeid +";" +expires+"; path=/";
  setStoreNameCookieAndGaStoreNameCookie(store_name, expires);      
  location.reload();
  return;
}

function setStoreNameCookieAndGaStoreNameCookie(storeName, expires) {
  document.cookie = storenameCookieKey + "="+ storeName+";" +expires+"; path=/";
  document.cookie = gaStorenameCookieKey + "="+ storeName+";" +expires+"; path=/";
}

function getMapDataURL()
{
   return '//www.coastappliances.ca/cdn/shop/t/2549/assets/map.json?v=48669215870759471841756494722';
}


function GetSelectedStoreName()
{
  	var selectedStoreName = readCookie(storenameCookieKey);    
  	if (selectedStoreName != null)
    {
    	return selectedStoreName;
      
    }
  
  	return null;
}


/** this will load the current store **/
$(document).ready(function() {
	var selectedStore = readCookie(storeCookieKey);   
    var date = new Date();
  	date.setTime(date.getTime()+(1*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  	if (selectedStore != null)
    {
      storeinfo = JSON.parse(selectedStore);
      var province = storeinfo.province;
      var storeId = storeinfo.storeid;
      //var url = location.protocol + '://'+ location.host + '/pages/storelist-json';
      //var url = 'https://coastappliances.myshopify.com/pages/storelist-json'
      //alert(url);
      
     
     var url = getStoreLocationsJson();
     // alert(content);
      
      var storename = '';
      var storestatus = '';
      var hoursOfOperation = '';
      var custom_msg = '';
      var weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";
      
      $.getJSON(url, function(data) {
        for (var i in data) {
          if (storeId == data[i].id)
          {
           storename = data[i].storeDisplayName;
           custom_msg = data[i].custom_msg;
           //console.log(data[i].custom_msg);
            var d = new Date();
  			var n = d.getDay();
            var isDaylightSavingsEnabled = data[i].daylights_savings_enabled;
            var utcOffset = GetStoreUtcOffset(data[i].utc_offset, isDaylightSavingsEnabled);

            for (var j in data[i].hours_of_operation) {
              if (n == data[i].hours_of_operation[j].day_of_week)
              {
                var isclosed = data[i].hours_of_operation[j].closed;
                
                storestatus = GetStoreStatus(data[i].hours_of_operation[j].open_hr,
                                             data[i].hours_of_operation[j].open_min,
                                             data[i].hours_of_operation[j].close_hr,
                                             data[i].hours_of_operation[j].close_min,
                                             utcOffset, isclosed);
                if (isclosed == false)
                {
                 // if (storestatus == 'Open')
                 // {
                 	hoursOfOperation = ' • '+ weekday[n] + ' ' + data[i].hours_of_operation[j].open_time + ' - ' + data[i].hours_of_operation[j].close_time;

                 // }                    
                }
                else
                {
                  hoursOfOperation = ' • '+ weekday[n];
                }
                
              }              
            }
            break;
          }              
        }
       var storehtml = '<strong>' + storename +'</strong> <a class="change-store">Change</a><div><span><strong>' + storestatus +' </strong>'+hoursOfOperation+'</span>';
       storehtml += '<div class="store__cutom-msg"><span>' + custom_msg + '</span></div>';
       storehtml += '</div>';
       $(".__currentStore").html(storehtml);
       $('.change-store').click(() => {
        changeStore();
       });
       setStoreNameCookieAndGaStoreNameCookie(storename, expires); 
    });
      
    }
});


function GetStoreStatus(openHr, openMin, closedHr, closedMin, utcOffset, isclosed)
{
  
  if(isclosed == true)
  {
    return "Closed";
  }
  
  //var utcnow = Date.now();
  //var d = Date(Date.now()); 
  //a = d.toString() 
  //alert(calcTime(-7).toLocaleString());
  //alert(calcTime(-7));
  
  // get store time 
 var currentTimezoneTime = calcTime(utcOffset);
 var dateOpenTime = getDateTime(currentTimezoneTime, openHr, openMin);
 var dateCloseTime = getDateTime(currentTimezoneTime, closedHr, closedMin);
  
 
 var status ='';
 //alert(currentTimezoneTime);
 if (currentTimezoneTime > dateOpenTime && currentTimezoneTime < dateCloseTime)
 {
   status = "Open";
 }
 else
 {
	 status = "Closed";
 }
 
  return status;
}


function getDateTime(currentTimezoneTime, hrs, mins){
  //
 // var d = new Date();
 // var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
 // var utcMidnight = 
  var date = new Date(currentTimezoneTime);
  date.setHours(hrs);
  date.setMinutes(mins);
  date.setSeconds(0);
  date.setMilliseconds(0);
  //alert(date);
  return date;
}

function changeStore()
{  
  var page_type = window.theme.pageType;
  var date = new Date();
  date.setTime(date.getTime()-(2*24*60*60*1000));
  var expires = "expires="+date.toGMTString();
  //alert(expires);
  //var cookieKey = "selected-Coast-store";
  //alert(storeCookieKey);
  document.cookie = storeCookieKey + "=;" +expires+"; path=/";
  var deetedcookie = readCookie(storeCookieKey);
  if (deetedcookie != null)
  {
  	//alert('TODO COOKIE NOT DELETED, INVESTIGATE WHY');
  }
  if(page_type == 'collection'){
    window.location.href =  window.location.href.split("?")[0];
  }else{
    location.reload(true);
    return;
  }
}

function calcTime(offset) {
    // create Date object for current location
    var d = new Date();

    // convert to msec
    // subtract local time zone offset
    // get UTC time in msec
    var utc = d.getTime() + (d.getTimezoneOffset() * 60000);

    // create new Date object for different city
    // using supplied offset
    return new Date(utc + (3600000*offset));

}

  
function GetProvince(position)
{
  //alert('GetProvince');
        
  try {
 //if (readCookie('selected-province') == null)
 if (readCookie(provincecookieKey) == null)   
 {
   var geocoder = new google.maps.Geocoder(); //alert(geocoder);
   var   latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
      geocoder.geocode({
          'latLng': latlng
      }, function(results, status) { //alert(status);
          if (status === 'OK') {
              if (results[1]) {
                  //console.log(results);
                var exit = false;
                  for (var i = 0; i < results[0].address_components.length; i++) {
                      for (var b = 0; b < results[0].address_components[i].types.length; b++) {
                          switch (results[0].address_components[i].types[b]) {
                              case 'administrative_area_level_1':
                                 var province = results[0].address_components[i].short_name;
                              	 // try to load ddl 
                              	 //alert(province);
                                //if (readCookie('selected-province') == null)
                               // {
                                	$('.store-selector__ddlProvince').val(province).change();
                                      exit = true;

                               // }
                                   	break;


                          }
                      }
                    if (exit) {break;}
                  }
              } else {
                  //alert("No results found");
              }
          } else {
              //alert("Geocoder failed due to: " + status);
          }
      });  
 }
    
  }
  catch(err){//alert(err);
  };
  
} 


function GetSelectedStoreProvince(_callback)
{
  	var selectedStore = readCookie(storeCookieKey);    
  	if (selectedStore != null)
    {
      storeinfo = JSON.parse(selectedStore);
      var province = storeinfo.province;
      
      if (province == "")
      {
		province = $('#selected-store-province-hidden').val();
      }
      return province;
    }
  	return "";
}


$(document).ready(function() {
  
  var url = getStoreLocationsJson();
  var selectedStore = readCookie(storeCookieKey);  
  //var storeId = storeinfo.storeid;
  if (selectedStore != null)
  {
    storeinfo = JSON.parse(selectedStore);
    var storeId = storeinfo.storeid;
    $.getJSON(url, function(data) {
    for (var i in data) {
      if (storeId == data[i].id)
      {
        $('#selected-store-province-hidden').val(data[i].province);
      }
     }              
          
  	}
    );    
  }

});
/**
$(document).ready(function() {
  
  var postalCode =  readCookie(postalCodeCookieKey);
  if (postalCode == null)
  {
      $.get("http://ipinfo.io", function(response) {
    		//console.log(response.postal);
        WriteCookie(postalCodeCookieKey, response.postal, 7);
		}, "jsonp");
  }
  

  });
**/

function ShowStoreSelectorPopup()
{
  var geocookie = readCookie(geoCookieKey); 
  var storecookie = readCookie(storeCookieKey); 
  if (geocookie != null && storecookie == null)
  {
   		return true; 
  }
  else {   
	
   		return false; 
  }
  
}

/** this function has 1 hr of innacuracy but for our purposes it works **/
function IsCurrentDateOnDaylightSavingsRange(utcOffset)
{
  var currentTimezoneTime = calcTime(utcOffset);  
  var ds_start_year = 2025;
  var ds_start_month = 3;
  var ds_start_day = 9;
  var ds_end_year = 2025;
  var ds_end_month = 11;
  var ds_end_day = 2;
  var ds_start = new Date(ds_start_year, ds_start_month - 1, ds_start_day);
  var ds_end =  new Date(ds_end_year, ds_end_month - 1, ds_end_day, 23, 59, 59);
  
  if (currentTimezoneTime > ds_start && currentTimezoneTime < ds_end)
  {
    return true;
  }
  else 
  {
    return false;
  }
  
  
}


function GetStoreUtcOffset(utcOffset, isDailightSavingsEnabled)
{
    
  if (isDailightSavingsEnabled == true)
  {
    
   var isDailightSavings = IsCurrentDateOnDaylightSavingsRange(utcOffset); 
   
   if (isDailightSavings == true)
   {
         return utcOffset + 1;
   }
   else 
   {
      return utcOffset;
   }
  }
  else 
  {
    return utcOffset;
  }
}
